import { Api } from '../../utils/ApiService';
import { Helper } from '../../utils/helper';

export interface BaseStore {
  helper: Helper;
  api: Api;
  endpointNews: string;
  endpointJobs: string;
  endpointWatch: string;
  endpointCompany: string;
  endpointChat: string;
  endpointSales: string;
  endpointChangePassword: string;
  endpointAgent: string;
  endpointPermissions: string;
  endpointAdminRag: string;
  hasNoResponse: (response: unknown) => boolean;
}

export const createBaseStore = (): BaseStore => {
  const helper = new Helper();

  return {
    helper,
    api: new Api(),
    endpointNews: helper.getBaseUrl + `/api/news`,
    endpointJobs: helper.getBaseUrl + `/api/jobs`,
    endpointWatch: helper.getBaseUrl + `/api/topic`,
    endpointCompany: helper.getBaseUrl + `/api/company`,
    endpointChat: helper.getBaseUrl + `/api/chat`,
    endpointSales: helper.getBaseUrl + `/api/sales`,
    endpointChangePassword: helper.getBaseUrl + `/api/changePassword`,
    endpointAgent: helper.getBaseUrl + `/api/agent`,
    endpointPermissions: helper.getBaseUrl + `/api/permissions`,
    endpointAdminRag: helper.getBaseUrl + `/api/admin/rag`,
    hasNoResponse: (response: unknown): boolean => {
      if (response == null) {
        return true;
      }
      if (Array.isArray(response) || typeof response === 'string') {
        return response.length === 0;
      }
      return false;
    }
  };
};

export const applyBaseStore = (target: BaseStore) => {
  Object.assign(target, createBaseStore());
};
